<template>
	<div>
		<div class="mb-12">
			<v-form v-model="valid">
				<v-row>
					<v-col cols="12" md="6">
						<v-text-field v-model="form.personalMessageTo" label="Til" class="prime" placeholder="Mamma, Pappa, Tante..." :rules="rules.to" maxlength="18" counter />
					</v-col>
					<v-col cols="12" md="6">
						<v-text-field v-model="form.personalMessageFrom" label="Fra" class="prime" placeholder="Ditt navn, Mamma, Pappa..." :rules="rules.from" maxlength="25" counter />
					</v-col>
				</v-row>

				<v-textarea
					:key="autoGrowPersonalMessageKey"
					v-model="form.personalMessage"
					label="Personlig melding"
					:rules="rules.personalMessage"
					class="prime mt-2"
					placeholder="Gratulerer med dagen, Fordi du fortjener det..."
					persistent-hint
					hint=" "
					auto-grow
					:counter="200"
					maxlength="200"
					@keydown="onKeyDown"
				/>
				<v-expand-transition>
					<div v-if="showPersonalMessageSuggestions">
						<div>Dårlig tid eller fantasi? Bruk et av våre forslag!</div>
						<div class="mt-2">
							<v-chip v-for="suggestion in personalMessageSuggestions" :key="suggestion.text" class="d-inline-block mr-2 mb-3" small @click="setPersonalMessage(suggestion.message)">{{
								suggestion.text
							}}</v-chip>
						</div>
					</div>
				</v-expand-transition>
			</v-form>
		</div>

		<v-btn text @click="currentStep--">Tilbake</v-btn>
		<v-btn color="primary" depressed @click="currentStep++" :disabled="!valid">Gå videre</v-btn>
	</div>
</template>

<script>
import { GiftCardPurchaseDetails } from '@/services/models';
import { replaceEmojiisWithText, textContainsEmojis } from '@/utils/fn';
import { isEqual } from 'lodash-es';

export default {
	name: 'buy-giftcard-receiver-info',
	props: {
		giftcard: GiftCardPurchaseDetails,
		value: null // Current step
	},
	data() {
		return {
			form: null,
			rules: {
				to: [v => !!v || 'Feltet er påkrevd', v => v.length <= 18 || 'Maks. 18 tegn tillatt'], //, v => !textContainsEmojis(v) || 'Tillater ikke emoji.'],
				from: [v => !!v || 'Feltet er påkrevd', v => v.length <= 25 || 'Maks. 25 tegn tillatt'], //, v => !textContainsEmojis(v) || 'Tillater ikke emoji.'],
				personalMessage: [
					v => !!v || 'Feltet er påkrevd',
					v => v.length <= 200 || 'Maks. 200 tegn tillatt',
					v => v.split(/\r\n|\r|\n/).length < 8 || 'Fjern et eller flere linjeskift.'
					//v => !textContainsEmojis(v) || 'Tillater ikke emoji.'
				]
			},
			valid: false,
			autoGrowPersonalMessageKey: false
		};
	},
	methods: {
		async fetchPersonalMessages() {
			if (!this.personalMessageSuggestions.length) {
				await this.$store.dispatch('giftcard/getPersonalMessages');
			}
		},
		setPersonalMessage(message) {
			message = message.replace('{messageFrom}', this.form.personalMessageFrom).replace('{messageTo}', this.form.personalMessageTo);
			this.form.personalMessage = message;
		},
		onKeyDown(/*event*/) {
			// const key = event.keyCode || event.charCode;
			// Allow backslash and delete if validation is not OK
			// if (
			// 	!(key == 8 || key == 46) ||
			// 	(this.rules.personalMessageMaxLength(this.form.personalMessage) !== true && this.rules.personalMessageMaxLineBreaks(this.form.personalMessage) !== true)
			// ) {
			// 	event.preventDefault();
			// 	return;
			// }
		}
	},
	computed: {
		personalMessageSuggestions() {
			return this.$store.state.giftcard.personalMessages || [];
		},
		showPersonalMessageSuggestions: function() {
			return this.form.personalMessageFrom.length && this.form.personalMessageTo.length;
		},
		personalMessageContainsEmojis() {
			if (this.form) {
				return textContainsEmojis(this.form.personalMessage) || textContainsEmojis(this.form.personalMessageFrom) || textContainsEmojis(this.form.personalMessageTo);
			}
			return false;
		},
		currentStep: {
			get() {
				return this.value || -1;
			},

			set(value) {
				this.$emit('input', value);
			}
		}
	},
	watch: {
		personalMessageContainsEmojis(newValue) {
			/* make sure we replace emojis until we handle them in the PDF and physical product
			 * Replace emojiis with text emoji.
			 */
			if (newValue) {
				this.form.personalMessage = replaceEmojiisWithText(this.form.personalMessage);
				this.form.personalMessageFrom = replaceEmojiisWithText(this.form.personalMessageFrom);
				this.form.personalMessageTo = replaceEmojiisWithText(this.form.personalMessageTo);
			}
		},
		form: {
			deep: true,
			handler(form) {
				if (form) {
					this.$emit('update:giftcard', new GiftCardPurchaseDetails(form));
				}
			},
			immediate: true
		},

		giftcard: {
			deep: true,
			handler(giftCard) {
				if (giftCard && !isEqual({ ...giftCard }, this.form)) {
					this.form = { ...giftCard };
				}
			},
			immediate: true
		}
	},

	created() {
		this.fetchPersonalMessages();
	}
};
</script>
